const lock_cart_until_update = () => {
    document.getElementById('CartPageForm').style.pointerEvents = 'none'
    document.getElementById('CartPageForm').style.opacity = 0.15 
}

// also set data-attr, do this first. & everytime data changes on screen without hard reload, run it again
const beautify_order_notes = () => {

  document.querySelectorAll('.pp-bundle-container').forEach(d=>{
    let text_info = d.querySelector('.cart__item--name').textContent.trim().split('Bundle items:')[1]
    d.setAttribute('data-attr', text_info) 

    if (text_info === undefined) return false // runs twice for some reason, so just return if empty

    let bundle_names = text_info.split('--').filter(e=>e.includes(':')).map(e=>e.split(':')[1].trim())
    let div = document.createElement('div')
    div.innerHTML = `
    <ul class='bundle-items-ul'>
        <li>1. ${bundle_names[0]}</li>
        <li>2. ${bundle_names[1]}</li>
        <li>3. ${bundle_names[2]}</li>
        <li>4. ${bundle_names[3]}</li>
        <li>5. ${bundle_names[4]}</li>
        <li>6. ${bundle_names[5]}</li>
        <li>7. ${bundle_names[6]}</li>
    </ul>
    `
    
    d.querySelector('.cart__item--name').querySelector('div').innerHTML = div.outerHTML
    let t =  d.querySelector('.cart__item--name').innerHTML.split('Bundle items:1:')[0] 
    d.querySelector('.cart__item--name').innerHTML = t

  })
}

beautify_order_notes()

// needed for setting new cart icon count
const get_bundle_count = async() => {
  return new Promise((resolve, reject) => {
      // GET CART
      fetch(window.Shopify.routes.root + 'cart.js').then((res) => {
        res.json().then((data) => {
          let count = data.items.filter(e=> {
            return e.product_title === 'Bundle Product'
          }).length
          resolve(count)
        })
      })
      .catch((error) => {
        console.log('error 25')
        console.error('Error:', error);
      });
  })
}
  
const get_variants_from_text = (text_info) => {
    let name_array_tmp = text_info.split(' -- ')
    name_array_tmp.pop()
    let name_array = name_array_tmp.map(e=>{ return e.split(':')[1].trim() })
    let variant_ids = []

    for (let word of name_array) {
      let variant_id = null
      try {
        variant_id = [...document.querySelectorAll('.pp-bundle')].find(e=> {
          // return e.querySelector('a.cart__product-name').textContent.split('~')[0].trim() === word
          return e.querySelector('a.cart__product-name').textContent.trim() === word
        }).querySelector('a.cart__product-name').href.split('variant=')[1]
      } catch(e) {
        // bundle container exist but no bundle-item in cart.
      }
      variant_ids.push(variant_id)
    }
    return variant_ids
}

const set_custom_delete_btn = () => {
  document.querySelectorAll('.pp-bundle-container').forEach(div => {
    let bundle_container_delete_btn = div.querySelector('.js-qty__adjust--minus')

    div.querySelector('.delete-bundle').addEventListener('click', (e) => {
      lock_cart_until_update()
      e.preventDefault()
      // Deleting bundle... get bundle infos from bundle note, then delete them.
      let text_info = div.getAttribute('data-attr')
      let bundle_variant_ids = get_variants_from_text(text_info)
      // console.log(bundle_variant_ids)

      let uniq = [...new Set(bundle_variant_ids)];
      let arr = uniq.map(e => ({variant_id:e, count:getOccurrence(bundle_variant_ids, e)}))

      // console.log(arr)
      delete_bundle_items(arr).then(d => {
        bundle_container_delete_btn.click()
        let default_text = document.querySelector('#CartPageForm').textContent

        // check cart updates, and when there is a change in cart, refresh. otherwise you will see not prettified order note
        let myInterval3 = setInterval(function () {
          if (default_text != document.querySelector('#CartPageForm').textContent) {
            clearInterval(myInterval3)
            location.reload();
          }

        else {
          // console.log('Not updated yet.')
        }
      }, 100);
      })
  })
})
}

function getOccurrence(array, value) {
  var count = 0;
  array.forEach((v) => (v === value && count++));
  return count;
}

const delete_bundle_items = async(bundle_items) => {

  // bundle_items = {variant_id, count}
  let data2 = {
      updates: {}
  }

  let cart_info = get_cart_info()
  for (let i=0; i<bundle_items.length; i++) {    
      // SET PRODUCT QUANTITY IN CART
      let item_cart_amount = 0
      try {
        item_cart_amount = cart_info.find(e=>bundle_items[i].variant_id === e.variant_id).count
      } catch(e) {}
    
      let set_count = item_cart_amount - bundle_items[i].count
      if (set_count < 0) set_count = 0
      data2.updates[bundle_items[i].variant_id] = set_count
  }

  let r1 = await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data2)
  })

  let r2 = await r1.json()

  // console.log('All delete operations are completed. You may refresh now.')  
  // location.reload();
  // no need to return promise?
  return(true)
}

// learn how many "bundle items" we have in cart
const get_cart_info = () => {
  let arr = []
  document.querySelectorAll('.pp-bundle').forEach(d => {
    let variant_id = d.querySelector('.pp-bundle a').href.split('variant=')[1]
    let count = d.querySelector('.js-qty__num').value
    arr.push({variant_id, count})
  })
  return arr
}

let bundle_items = []

/* display bundle items only if necessary, also append bundle items to container as text */
if (document.querySelector('.pp-bundle-container') === null) {
  document.querySelectorAll('.pp-bundle').forEach(d=>d.style.display='table-row')
} else {
    set_custom_delete_btn()
}

// moved from theme.liquid
// only do it for non-bundle items. bundle products have their own handler.
// also, only do these if there is a bundle product in the cart.
if (document.querySelectorAll('.pp-bundle-container').length > 0) {
  document.querySelectorAll('.non-bundle-item .js-qty__wrapper').forEach(d=>{
    let current_value = parseInt(d.querySelector('input').value)
    d.querySelectorAll('.js-qty__adjust').forEach(b=>{
      b.addEventListener('click', () => {
        let myInterval = setInterval(function () {
          if (document.querySelector('#CartPageForm').textContent.includes('Bundle items:1: ')) {
            clearInterval(myInterval)
            location.reload();
          }
          else {
            // console.log('Not updated yet.')
            document.querySelector('#CartPageForm').style.opacity='0.15'
          }
        }, 120);

      })
    })

    // also trigger on text input
    d.querySelector('input').addEventListener('focusout', (e) => {
      let updated_val = d.querySelector('input').value
      if (current_value.toString() === updated_val) {
        // console.log('Already same.')
      } else {
        // console.log('New updated value : ' + updated_val)
        let myInterval = setInterval(function () {
          if (document.querySelector('#CartPageForm').textContent.includes('Bundle items:1: ')) {
            clearInterval(myInterval)
            location.reload();
          }
          else {
            // console.log('Not updated yet.')
            document.querySelector('#CartPageForm').style.opacity='0.15'
          }
        }, 120);
      }
    })
})
}
